import React from 'react';

type Props = {};

const RotaryFeedthroughs = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 60 57.013"
			className={className}
		>
			<g fill="currentColor">
				<path d="M21.475 8.328A21.935 21.935 0 1 0 30 6.606a21.978 21.978 0 0 0-8.525 1.722Zm24.765 9.228a19.549 19.549 0 1 1-8.616-7.1 19.493 19.493 0 0 1 8.616 7.1Z" />
				<path d="M2.68 24.705A27.586 27.586 0 0 1 30 .927V0A28.512 28.512 0 0 0 1.753 24.642L0 24.524l1.956 3.983 2.47-3.685-1.747-.117Z" />
				<path d="m58.043 28.506-2.47 3.685 1.747.117A27.586 27.586 0 0 1 30 56.086v.927a28.512 28.512 0 0 0 28.247-24.642l1.753.118-1.956-3.983Z" />
				<path d="M25.104 31.278a5.625 5.625 0 0 0 9.767.042l-.351-.2.351.2a5.626 5.626 0 1 0-9.767-.042Zm8.563-.654a4.212 4.212 0 0 1-2.972 2.057V24.33a4.233 4.233 0 0 1 2.972 6.293Zm-4.363 2.059a4.232 4.232 0 0 1 0-8.351Z" />
				<path d="M28.77 13.495a1.74 1.74 0 1 0 1.231-.51 1.739 1.739 0 0 0-1.231.51Z" />
				<path d="M22.248 18.087a1.741 1.741 0 0 0 2.365-2.385 1.741 1.741 0 1 0-2.365 2.385Z" />
				<path d="M18.935 20.109a1.738 1.738 0 1 0 .644.649 1.739 1.739 0 0 0-.644-.649Z" />
				<path d="M17.958 28.506a1.741 1.741 0 1 0-.51 1.231 1.739 1.739 0 0 0 .51-1.231Z" />
				<path d="M18.921 33.883a1.741 1.741 0 0 0-1.728.007 1.741 1.741 0 1 0 1.728-.007Z" />
				<path d="M23.979 38.935a1.723 1.723 0 0 0-.869-.233 1.742 1.742 0 0 0-1.509.87 1.74 1.74 0 1 0 2.378-.637Z" />
				<path d="M30 40.548a1.741 1.741 0 1 0 1.231.51 1.739 1.739 0 0 0-1.231-.51Z" />
				<path d="M37.747 38.927a1.741 1.741 0 0 0-2.365 2.385l.351-.2-.351.2a1.741 1.741 0 1 0 2.365-2.385Z" />
				<path d="M42.805 33.891a1.724 1.724 0 0 0-.869-.233 1.742 1.742 0 0 0-1.509.87 1.741 1.741 0 0 0 .637 2.378l.2-.351-.2.351a1.741 1.741 0 0 0 1.74-3.015Z" />
				<path d="M42.042 28.506a1.741 1.741 0 1 0 .51-1.231 1.739 1.739 0 0 0-.51 1.231Z" />
				<path d="M41.078 23.131a1.741 1.741 0 0 0 1.728-.007l-.2-.351.2.351a1.742 1.742 0 1 0-1.728.007Z" />
				<path d="M36.021 18.079a1.741 1.741 0 0 0 2.378-.637l-.351-.2.351.2a1.74 1.74 0 1 0-2.378.637Z" />
				<path d="M21.645 28.502a8.356 8.356 0 1 0 2.447-5.907 8.33 8.33 0 0 0-2.447 5.907ZM30 21.538a6.963 6.963 0 1 1-4.925 2.039A6.941 6.941 0 0 1 30 21.542Z" />
			</g>
		</svg>
	);
};

export default RotaryFeedthroughs;
